<template>
  <div
    :style="{height: wrapHeight}"
    class="default-box"
  >
    <el-table
      id="default-table"
      ref="defaultTable"
      :data="tableData"
      :height="height"
      :border="border"
      cell-class-name="cell-wrap white"
      header-cell-class-name="header-cell"
      row-class-name="row"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="selection"
        :selectable="selectable"
        width="68px"
        type="selection"
        align="center"
        header-align="center"
      />
      <el-table-column
        v-if="index"
        label="序号"
        width="80px"
        type="index"
        align="center"
        header-align="center"
      />
      <el-table-column
        v-for="(column, index) in columnData"
        :key="column.prop + index"
        :prop="column.prop"
        :label="column.label"
        :width="column.width"
        :min-width="column.minWidth"
        :formatter="(r, c, value) => getFormatter(r, c, value, column.formatter)"
        :show-overflow-tooltip="column.overflow"
        class-name="handle"
        align="center"
        header-align="center"
      />
      <el-table-column
        v-if="selector"
        :label="selector.title"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-select
            :ref="`${scope.row.id}-selector`"
            v-model="scope.row[selector.field]"
            :loading="goodsLoading"
            :disabled="!scope.row.saleable"
            size="small"
            remote
            @visible-change="remoteGoodsMethod(arguments, scope.row)"
            @change="handleChangeSelector(scope.row)">
            <el-option
              v-for="(item) in scope.row.goodsInfoList"
              :key="item.id"
              :label="item.label"
              :value="item.id"/>
          </el-select>
          <p
            v-if="scope.row.saleable && !scope.row.inUse">
            商品规格信息发生改变，请重新选择
          </p>
        </template>
      </el-table-column>
      <el-table-column
        v-if="radio"
        :label="radio.title"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row[radio.status]"
            active-color="#13ce66"
            inactive-color="#CCCCCC"
            @change="handleChangeSwitch"/>
        </template>
      </el-table-column>
      <el-table-column
        v-if="option"
        :width="opWidth"
        label="操作"
        class="option-wrap"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div
            class="button-list">
            <div
              v-for="(op, index) in options"
              :key="index"
              class="table-button">
              <el-button
                v-if="isOptionShow(op, scope)"
                :loading="op.waiting && Array.isArray(op.waiting) ? op.waiting.some(v => v === scope.$index) : false"
                :disabled="!isOptionShow(op, scope)"
                type="text"
                style="border-radius: 4px;"
                @click="($event) => {
                  op.onclick(scope.row, op)
                  clearButtonFocus($event)
                }"
              >
                {{ op.name }}
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="optionDate"
        :width="opDateWidth"
        label="操作时间"
        class="option-wrap"
        align="center"
        header-align="center"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row[optionDateField] | formatTime }}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="pagination"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      style="margin-right: 20px"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import * as api from '@/api/index'

export default {
  props: {
    wrapHeight: {
      type: String,
      default: undefined
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    selectable: {
      type: Function,
      default: () => { return true }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    },
    columnData: {
      type: Array,
      default: function () {
        return []
      }
    },
    border: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Boolean,
      default: false
    },
    index: {
      type: Boolean,
      default: false
    },
    option: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: true
    },
    options: {
      type: Array,
      default: () => []
    },
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 20
    },
    total: {
      type: Number,
      default: 1
    },
    opWidth: {
      type: String,
      default: '100px'
    },
    optionDate: {
      type: Boolean,
      default: false
    },
    optionDateField: {
      type: String,
      default: 'auditTime'
    },
    opDateWidth: {
      type: String,
      default: undefined
    },
    radio: {
      type: Object,
      default: () => null
    },
    selector: {
      type: Object,
      default: () => null
    },
    specifiedKey: { // 用来判断某个操作按钮是否显示的key
      type: String,
      default: ''
    }
  },
  data () {
    return {
      goodsLoading: false
    }
  },
  methods: {
    optionLoading (op) {
      return op.loadings?.includes(op.name)
    },
    isOptionShow (item, scope) {
      let flag = true
      // console.log(item, this.specifiedKey)
      if (item.state && Array.isArray(item.state)) {
        if (item.specifiedKey && Array.isArray(item.specifiedKey)) {
          // specifiedKey数组中的每个元素对应state中对应下标的元素，因此用一个双重循环进行判断，如果出现false值则赋值给flag，表示该按钮不可用，否则该按钮默认可用
          item.specifiedKey.forEach((v, index) => {
            let flagTemp = item.state[index].some(state => {
              if (typeof state === 'boolean') {
                return state === Boolean(scope.row[v])
              } else {
                return state === scope.row[v]
              }
            })
            if (!flagTemp) flag = flagTemp
          })
        } else {
          flag = item.state.some(v => v === scope.row[item.specifiedKey])
        }
      }
      return flag
    },
    handleSelectionChange (selection) {
      this.$emit('selection-change', selection)
    },
    handleSizeChange (val) {
      this.$refs.defaultTable.bodyWrapper.scrollTop = 0
      this.$emit('update:page-size', val)
      this.$emit('pagination-change')
    },
    handleCurrentChange (val) {
      this.$refs.defaultTable.bodyWrapper.scrollTop = 0
      this.$emit('update:current-page', val)
      this.$emit('pagination-change')
    },
    getFormatter (r, c, value, formatter) {
      if (!formatter) {
        return this.$options.filters.noData(value, '-')
      }

      return this.$options.filters.noData(formatter(r, c, value), '-')
    },
    // 更改选项
    handleChangeSelector (row) {
      document.body.click()
      this.$emit('selector-change', row)
    },
    // 更改状态
    handleChangeSwitch (val) {
      this.$emit('status-change', val)
    },
    // 去掉表格中button的focus状态
    clearButtonFocus (e) {
      let target = e.target
      if (target.nodeName === 'SPAN') {
        target = e.target.parentNode
      }
      target.blur()
    },
    toggleSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.defaultTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.defaultTable.clearSelection()
      }
    },
    remoteGoodsMethod (arg, row) {
      if (arg[0]) {
        this.goodsLoading = true
        api.getSellDetail(row.originId).then(res => {
          const data = res.data.specList || []
          if (data.length && data[0].sellMethod === 'PIC_ALL') {
            this.$set(row, 'goodsInfoList', [])
          } else if (data.length && data[0].sellMethod === 'OUT_LINK') {
            this.$set(row, 'goodsInfoList', [])
          } else if (data.length) {
            const list = res.data.specList || []
            list.forEach(item => {
              this.$set(item, 'label', `${item.ownSpec && item.ownSpec.sizeName} ${item.sellParam.px}x${item.sellParam.py}`)
            })
            this.$set(row, 'goodsInfoList', list)
            console.log(row)
          } else {
            // this.$message.error('该商品未上架')
          }
        }).finally(_ => {
          this.goodsLoading = false
        })
      }
    }
  }
}
</script>

<style lang="stylus">
@import './index.styl'
</style>

<style>
</style>
